import { Navigate, useLocation, useParams, type Params } from 'react-router';

/**
 * Builds a route element that permanently forwards an old URL to its new
 * path, keeping URL params, the query string and router state.
 */
const legacyRedirect = (to: (params: Params) => string) => {
  const LegacyRedirect = () => {
    const params = useParams();
    const { search, state } = useLocation();
    return <Navigate to={`${to(params)}${search}`} state={state} replace />;
  };
  return LegacyRedirect;
};

export default legacyRedirect;
